<template>
  <div class="">
    <label for="">اشتراک</label>
    <div class="selected-item rounded-pill cursor-pointer" @click="clearFilter" v-if="selectedItem != null">
      {{ selectedItem.name }}
      <b-icon icon="x-circle"/>
    </div>
    <form @submit.prevent="submitSubscription">
      <input type="text" class="form-control" v-model="searchWord">
      <b-icon @click="submitSubscription" class="clear-icon" icon="search"/>
    </form>
    <div class="subscriptions rounded shadow p-3 mt-1 " v-if="subscriptions.length > 0">
      <div class="mb-3" v-for="subscription in subscriptions" @click="filterSubscriptions(subscription)">
        {{ subscription.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubscriptionFilter",
  data() {
    return {
      searchWord: '',
      subscriptions: [],
      selectedItem: null
    }
  },
  methods: {
    async loadSubscriptions(page) {
      let data = await this.$store.dispatch('Subscription/getSubscriptions', page)
      this.subscriptions = data.data.data.data
    },
    filterSubscriptions(value) {
      this.$emit('subscription', value)
      this.selectedItem = value
      this.subscriptions = []
    },
    submitSubscription() {
      this.$store.commit('Subscription/setFilters', {key: 'search', value: this.searchWord})
      this.loadSubscriptions()
    },
    clearFilter() {
      this.$emit('subscription', '')
      this.selectedItem = null
    }
  }
}
</script>

<style scoped>
.subscriptions {
  height: 120px;
  background: white;
  overflow: auto;
  position: absolute;
  width: 87%;
  z-index: 1350;
}

.clear-icon {
  position: absolute;
  top: 42px;
  left: 20px;
}


.selected-item {
  display: inline;
  margin-right: 10px;
  background: var(--primary);
  color: white;
  padding: 3px 5px;
  font-size: 12px;
}

</style>